import { type ComponentWorkflows, type WorkflowContext } from '../models/ai.model';

export type IndexedActionGroup = 'RowActions' | 'ItemActions' | 'BulkActions' | 'Actions';
export type ScalarActionGroup = 'RowClick' | 'ItemClick';
export type ActionGroup = IndexedActionGroup | ScalarActionGroup;
export type RecordActionGroup = 'RowActions' | 'ItemActions';

/**
 * `<elementId>.<group>[<index>]` for the array-typed properties
 * `<elementId>.<group>` no index - for the scalar ones
 */
function formatComponentWorkflowKey(elementId: string, group: ActionGroup, index?: number): string {
  return index === undefined ? `${elementId}.${group}` : `${elementId}.${group}[${index}]`;
}

export function buildComponentWorkflowKey(
  elementId: string,
  group: IndexedActionGroup,
  index: number,
): string;
export function buildComponentWorkflowKey(elementId: string, group: ScalarActionGroup): string;
export function buildComponentWorkflowKey(
  elementId: string,
  group: ActionGroup,
  index?: number,
): string {
  return formatComponentWorkflowKey(elementId, group, index);
}

export function getActionWorkflowContext(
  elementId: string,
  componentWorkflows: ComponentWorkflows,
  group: IndexedActionGroup,
  index: number,
): WorkflowContext | undefined;
export function getActionWorkflowContext(
  elementId: string,
  componentWorkflows: ComponentWorkflows,
  group: ScalarActionGroup,
): WorkflowContext | undefined;
export function getActionWorkflowContext(
  elementId: string,
  componentWorkflows: ComponentWorkflows,
  group: ActionGroup,
  index?: number,
): WorkflowContext | undefined {
  return componentWorkflows[formatComponentWorkflowKey(elementId, group, index)];
}

export function warnMissingComponentWorkflow(
  elementId: string,
  componentWorkflows: ComponentWorkflows,
  group: ActionGroup,
  index?: number,
): void {
  const missingKey = formatComponentWorkflowKey(elementId, group, index);
  const presentKeys = Object.keys(componentWorkflows).filter((key) =>
    key.startsWith(`${elementId}.`),
  );

  console.warn(
    `No workflow found for '${missingKey}'; workflows present for '${elementId}': ` +
      `${presentKeys.length ? presentKeys.join(', ') : 'none'}.`,
  );
}
